import React, { useReducer, createContext } from 'react';
import reducers from './reducers';
import actionCreators from './actions';

const initialState = {
  //-------LAYOUT VALUES-----/
  // layoutType: LAYOUT_TYPE_FULL,
  // themeType: THEME_TYPE_SEMI_DARK,
  // themeColor: DARK_BLUE,
  // navCollapsed: false,
  // navStyle: NAV_STYLE_DRAWER,


  //-------GENERAL VALUES------//
  pathname: "/",
  initURL: '',
  authUser: localStorage['user'] ? JSON.parse(localStorage['user']) : null
  // authUser: localStorage.getItem('user'),

};

const reducer = (state = initialState, { type, payload }) => {
  return reducers[(payload.success && type) || 'ERROR'](state, payload);
};

export const context = createContext(initialState);

export default ({ children }) => {

  const [state, dispatch] = useReducer(reducer, initialState);

  const actions = actionCreators(state, dispatch);

  return <context.Provider
    value={{ state, actions }}>
    {children}
  </context.Provider>;
};
